/*
 * Copyright (c) 2022-2022. Revo Digital
 * ---
 * Author: gabriele
 * File: AutoSaveFeature.ts
 * Project: mle-client-n
 * Committed last: 2022/5/18 @ 163
 * ---
 * Description:
 */

import {Feature} from '../common/Feature';
import {action, computed, makeObservable, observable} from 'mobx';
import {Editor} from '../../observables/Editor';

export const AUTO_SAVE_FNAME = 'auto-save';

export class AutoSaveFeature extends Feature<void, void, Editor> {
    private _timeout: NodeJS.Timeout | undefined = undefined;

    constructor(editor: Editor) {
        super(AUTO_SAVE_FNAME, undefined, editor, true);
        this._timeDelay = 5000;
        this._active = true;

        makeObservable(this);
    }

    @observable
    private _timeDelay: number;

    @computed
    public get timeDelay() {
        return this._timeDelay;
    }

    @observable
    private _active: boolean;

    @computed
    public get active() {
        return this._active;
    }

    init(): boolean {
        // Start main interval
        let shouldContinue = true;
        this._timeout = setInterval(() => {
            if (shouldContinue) {
                // Salva e controlla se è andato a buon fine. In caso negativo ferma il salvataggio automatico
                this.sourcePointer.saveFeature.encodeAndUpload().then(res => {
                    shouldContinue = res;

                    if (!res)
                        console.error('Salvataggio automatico fermato a causa di errori.');
                });
            }
        }, this._timeDelay);

        return true;
    }

    @action
    public setEnabled(value: boolean) {
        this._active = value;
    }

    @action
    public setTimeDelay(value: number) {
        this._timeDelay = value;
    }

    @action
    public suspendForTime(millis: number) {
        if (millis > 0) {
            this._active = false;

            setTimeout(() => this._active = true, millis);
        }
    }

    destroy(): boolean {
        // Remove timeout
        if (this._timeout)
            clearInterval(this._timeout);
        return false;
    }
}